import { render, staticRenderFns } from "./ScrollToUp.vue?vue&type=template&id=bc8fe546&scoped=true&"
import script from "./ScrollToUp.vue?vue&type=script&lang=js&"
export * from "./ScrollToUp.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToUp.vue?vue&type=style&index=0&id=bc8fe546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8fe546",
  null
  
)

export default component.exports